module.exports = __webpack_public_path__ + "img/zgw_quiz_night_creation.b0242332.png";